<template>
  <el-card shadow="never"
    ><el-page-header @back="goBack" :content="componentName"> </el-page-header>
    <el-divider></el-divider>
    <!-- 表单 -->
    <el-form ref="formNewCourse" :model="formNewCourse" label-width="80px">
      <!-- 课程名称 -->
      <el-form-item label="名称">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.section_name"
        ></el-input>
      </el-form-item>
      <!-- 章节 -->
      <el-form-item label="章节">
        <el-autocomplete
          :clearable="true"
          class="inline-input"
          style="width: 20%"
          :fetch-suggestions="querySearch"
          @select="handleSelect"
          size="mini"
          v-model="formNewCourse.chapter_name"
        ></el-autocomplete>
        <el-link
          style="margin-left: 20px"
          :underline="false"
          @click="addChapter"
          >添加章节</el-link
        >
      </el-form-item>
      <!-- 课程作者 -->
      <el-form-item label="作者">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCourse.author"
        ></el-input>
      </el-form-item>
      <!-- 封面 -->
      <el-form-item label="封面">
        <up-load
          @getImageURl="getImageURl"
          :default_image="formNewCourse.section_cover"
        ></up-load>
      </el-form-item>
      <!-- 简介 -->
      <el-form-item label="简介">
        <el-input
          style="width: 40%"
          type="textarea"
          v-model="formNewCourse.section_intro"
        ></el-input>
      </el-form-item>
      <!-- 提交表单 -->
      <el-form-item>
        <el-button size="mini" type="primary" @click="onSubmitNewSection"
          >立即保存</el-button
        >
        <el-button size="mini">取消</el-button>
      </el-form-item>
    </el-form>
    <!----------- 对话框 ------------->
    <el-dialog
      :title="course_name"
      :visible.sync="dialogSelectChapter"
      width="30%"
    >
      <el-input
        size="mini"
        v-model="chapterName"
        placeholder="请输入内容"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noSubmit">取 消</el-button>
        <el-button type="primary" @click="submitNewChapter">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
import { tpx_app } from "../../network/request";
export default {
  name: "creat-new-section",
  components: {
    "up-load": UpLoad,
  },
  data() {
    return {
      course_id: "",
      course_name: "",
      componentName: "修改章节信息",
      dialogSelectChapter: false,

      chapterName: "", // 章节名称
      chapterNameList: "", // 全部章名称
      formNewCourse: {},
    };
  },

  mounted() {
    this.formNewCourse = this.$route.params;
    this.getAllChapter();
  },
  watch: {
    course_id(value) {
      this.course_id = value;
    },
    formNewCourse(newValue) {
      this.formNewCourse = newValue;
    },
  },
  methods: {
    //  更新节信息
    onSubmitNewSection() {
      tpx_app({
        url: "renew_course_section",
        method: "POST",
        data: this.formNewCourse,
      }).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.$router.push({
            name: "course_content_manage",
            query: {
              course_id: this.formNewCourse.course_id,
            },
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: errmsg,
          });
        }
      });
    },
    //   上一页
    goBack() {
      this.$router.push({
        name: "course_content_manage",
        query: {
          course_id: this.formNewCourse.course_id,
        },
      });
    },
    // 取消
    noSubmit() {
      this.$router.push({
        name: "course_content_manage",
        query: {
          course_id: this.formNewCourse.course_id,
        },
      });
    },
    // 新增章节对话框
    addChapter() {
      this.dialogSelectChapter = true;
    },
    // handleSelect
    handleSelect(item) {
      this.formNewCourse.chapter_id = item.id;
    },
    // 提交新章节名
    submitNewChapter() {},
    // 获取章 名称列表
    getAllChapter() {
      tpx_app({
        url: "get_course_chapter",
        params: {
          course_id: this.formNewCourse.course_id,
        },
      }).then((res) => {
        const { errno, errmsg, data } = res.data;
        if (errno == "0") {
          this.chapterNameList = data;
        }
      });
    },

    getImageURl(value) {
      this.formNewCourse.section_cover = value;
    },

    // 自动匹配章
    querySearch(queryString, cb) {
      let chapters = this.chapterNameList;
      let results = queryString
        ? chapters.filter(this.createFilter(queryString))
        : chapters;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (chapters) => {
        return (
          chapters.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
  },
};
</script>

<style>
</style>